import { FormizoSchema } from "Components/LabIZO/Formizo/FormizoSchema.interface";

export const ErrorMessageSetting: FormizoSchema[] = [
  {
    header: "Network Problem",
  },
  {
    label: "TC",
    name: "SettingDoc.Config.networkProblem.TC",
    format: "textarea",
    variant: "outlined",
  },
  {
    label: "SC",
    name: "SettingDoc.Config.networkProblem.SC",
    format: "textarea",
    variant: "outlined",
  },
  {
    label: "EN",
    name: "SettingDoc.Config.networkProblem.EN",
    format: "textarea",
    variant: "outlined",
  },
  {
    header: "Resend",
  },
  {
    label: "TC",
    name: "SettingDoc.Config.resend.TC",
    format: "text",
    variant: "outlined",
  },
  {
    label: "SC",
    name: "SettingDoc.Config.resend.SC",
    format: "text",
    variant: "outlined",
  },
  {
    label: "EN",
    name: "SettingDoc.Config.resend.EN",
    format: "text",
    variant: "outlined",
  },
  {
    header: "Busy Network",
  },
  {
    label: "TC",
    name: "SettingDoc.Config.busyNetwork.TC",
    format: "text",
    variant: "outlined",
  },
  {
    label: "SC",
    name: "SettingDoc.Config.busyNetwork.SC",
    format: "text",
    variant: "outlined",
  },
  {
    label: "EN",
    name: "SettingDoc.Config.busyNetwork.EN",
    format: "text",
    variant: "outlined",
  },
];
